import React, { useEffect, useState } from 'react';
import { fetchVessels } from '../../lib/api';

const levelColor = (level) => {
  if (level >= 0.6) return '#7C9CB1';
  if (level >= 0.25) return '#90B0BF';
  return '#AAC6D4';
};

const VesselRegistry = () => {
  const [data, setData] = useState(null);
  useEffect(() => { fetchVessels().then(setData).catch(() => {}); }, []);

  if (!data)
    return <div data-testid="vessels-loading" className="h-40 bg-[#C1D7E2]/40 animate-pulse" />;

  return (
    <div data-testid="vessels-view" className="space-y-8">
      <header className="border-b border-[#C1D7E2] pb-6 flex flex-wrap items-end justify-between gap-3">
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#90B0BF] mb-2">
            Global Vessel Registry
          </p>
          <h3 className="font-serif text-3xl md:text-4xl text-[#7C9CB1] font-light">
            Every bottle, in the field.
          </h3>
        </div>
        <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-[#90B0BF]">
          {data.count} deployed
        </p>
      </header>

      <div data-testid="vessels-table" className="overflow-x-auto">
        <table className="w-full text-left">
          <thead>
            <tr className="border-b border-[#C1D7E2]">
              {['NFC ID', 'Product', 'Location', 'Level', 'Last Tap'].map((h) => (
                <th
                  key={h}
                  className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#90B0BF] py-4 pr-6 font-medium"
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.vessels.map((v, i) => (
              <tr
                key={v.bottle_id}
                data-testid={`vessel-row-${i}`}
                className="border-b border-[#C1D7E2]/60 hover:bg-[#C1D7E2]/15"
              >
                <td className="py-4 pr-6 font-mono text-sm text-[#7C9CB1]">{v.bottle_id}</td>
                <td className="py-4 pr-6 font-serif text-base text-[#7C9CB1]">
                  {v.product_name || v.product_slug || '—'}
                </td>
                <td className="py-4 pr-6 font-serif text-[#7C9CB1]">
                  {v.deployed_at || <span className="text-[#90B0BF] italic">Unassigned</span>}
                </td>
                <td className="py-4 pr-6">
                  <div className="flex items-center gap-3 min-w-[140px]">
                    <div className="flex-1 h-1.5 bg-[#C1D7E2]/40">
                      <div
                        className="h-full transition-[width] duration-500"
                        style={{
                          width: `${Math.round(v.level * 100)}%`,
                          background: levelColor(v.level),
                        }}
                      />
                    </div>
                    <span className="font-mono text-xs text-[#7C9CB1] whitespace-nowrap">
                      {Math.round(v.ml_current)}/{v.ml_capacity}ml
                    </span>
                  </div>
                </td>
                <td className="py-4 pr-6 font-mono text-[11px] text-[#90B0BF]">
                  {v.last_tap ? new Date(v.last_tap).toLocaleString() : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default VesselRegistry;
